module.exports = __webpack_public_path__ + "img/borderFormWhite.ca0ca890.svg";